export const REGULARS = {
	password: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[\w!@#$%^&*]{8,}$/,
	onlyNumbers: /^[0-9]+$/,
	numbers: /\d/g,
	hexColor: /^#([0-9A-F]{3}){1,2}$/i,
	phoneNumber: /^(\d{0,3})(\d{0,3})(\d*)$/,
	email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
	time: /^([01]?[0-9]|2[0-3]):[0-5][0-9]/,
	domain: /^(\w{1,62}\.)+[A-Z]{2,62}$/gi,
	website: new RegExp(
		"^((ht|f)tp(s?)://)?[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(/?)([a-zA-Z0-9\\-.?,'/+&amp;%$#=_]*)?$",
	),
	protocol: /^(http|https):\/\//i,

	idFromUrl: /respondent\/[^/]+$/,
	fileName: /\/([^.]*)/,

	exceptLettersNumbersSpace: /[^0-9A-zÀ-ú\s]/gi,
	exceptEngLettersDigitsSymbols: /[^\w\s!@#$%^&*.,()\-\\]/i,

	handleBars: /{{{?(#[a-zA-Z]+ )?[a-zA-Z]+.[a-zA-Z]*}?}}/g,

	comment: /^[A-Za-z0-9 .~!@#$%^&*_+=`|\\(){}\[\]:;"'<>,?/]+$/,
	shortName: /^[a-zA-Z0-9\s]+$/,
	formalName: /^[a-zA-Z0-9\s&():;"]+$/,
	domainName: /^[a-zA-Z0-9\s-.]+$/,
	fileNameAttachment: /filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/,
};
